import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import { Spin } from "antd";
import { GoAlert } from "react-icons/go";
import GreenCheck from "../../../assets/icons/typcn_tick.svg";
import Logo from "../../../assets/img/skillgigs.png";
import { updateUserInfo } from "../../../redux/actions";
import { setCookie } from "../../../shared/helpers";
import { Auth } from "../../../config/aws-exports";
import {
  CommonAuthButton,
  EmailInput,
  Link,
  PasswordInput,
  SliderWrapper,
} from "../index";
import { NEW_ONBOARDING_ROUTES } from "../constants/routes.constants";
import { validateEmail } from "../utils/passwordUtils";
import styles from "../Newlogin/NewLogin.module.css";

export const Signin = () => {
  const dispatch = useDispatch();
  const history = useHistory();

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [emailFocused, setEmailFocused] = useState(false);
  const [greenCheck, setGreenCheck] = useState(false);
  const [showCheckIconEmail, setShowCheckIconEmail] = useState(false);
  const [loading, setLoading] = useState(false);
  const [errorMsg, setErrorMsg] = useState("");

  const validateEmailLive = (e) => {
    const value = e.target.value.toLowerCase();
    setEmail(value);
    setErrorMsg("");
    setShowCheckIconEmail(value.length > 0);
    setGreenCheck(validateEmail(value));
  };

  const handlePasswordChange = (e) => {
    setPassword(e.target.value);
    setErrorMsg("");
  };

  const isSigninDisabled = loading || !email || !password || !validateEmail(email);

  const handleSignin = async () => {
    if (isSigninDisabled) return;

    setLoading(true);
    setErrorMsg("");

    try {
      const normalizedEmail = email.toLowerCase();
      const user = await Auth.signIn({
        username: normalizedEmail,
        password,
      });

      if (user?.challengeName === "NEW_PASSWORD_REQUIRED") {
        history.push(
          `/force-password-change?email=${encodeURIComponent(normalizedEmail)}`
        );
        return;
      }

      const session = await Auth.currentSession();
      const token = session.getIdToken().getJwtToken();
      setCookie("token", token);
      dispatch(updateUserInfo(token));
      history.push("/auth");
    } catch (error) {
      const message =
        error?.message || "We could not sign you in. Please try again.";
      setErrorMsg(message);
    } finally {
      setLoading(false);
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    handleSignin();
  };

  return (
    <SliderWrapper>
      <div className={styles.formCard}>
        <div className={styles.brandWrap}>
          <img src={Logo} alt="SkillGigs" className={styles.brandLogo} />
        </div>

        <h2 className={styles.title}>Sign in to your account</h2>

        <form className={styles.form} onSubmit={handleSubmit}>
          <div
            className={
              !emailFocused
                ? greenCheck
                  ? styles.validInput
                  : showCheckIconEmail
                    ? styles.invalidInput
                    : ""
                : ""
            }
          >
            <EmailInput
              autoFocus
              required
              label="Email Address"
              value={email}
              handleChange={validateEmailLive}
              onFocus={() => setEmailFocused(true)}
              onBlur={() => setEmailFocused(false)}
              placeholder="Enter the email address"
              suffix={
                greenCheck ? (
                  <img src={GreenCheck} alt="valid" />
                ) : showCheckIconEmail && !emailFocused ? (
                  <GoAlert style={{ color: "#db2828" }} />
                ) : null
              }
            />
          </div>

          {showCheckIconEmail &&
            !greenCheck &&
            !emailFocused &&
            email?.length > 0 && (
              <p className={styles.errorText}>
                Looks like this email is incomplete
              </p>
            )}

          <PasswordInput
            required
            value={password}
            handleChange={handlePasswordChange}
            autoComplete="current-password"
          />

          {errorMsg && <p className={styles.errorText}>{errorMsg}</p>}

          <CommonAuthButton
            type="submit"
            className={styles.submitBtn}
            disabled={isSigninDisabled}
            loading={loading}
            label={loading ? <Spin size="small" /> : "Sign in"}
          />

        </form>
      </div>
    </SliderWrapper>
  );
};
